import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchalertprofiles } from "../Profiles/Reducers/actions";
import ChirpStackStep1 from "./Components/chirpstack-step1";
import ChirpStackStep2 from "./Components/chirpstack-step2";
import ChirpStackStep3 from "./Components/chirpstack-step3";
import ChirpStackStep4 from "./Components/chirpstack-step4";

const ChirpStackImportWizard = ({ fetchalertprofiles, alertprofile }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [chirpStackDevices, setChirpStackDevices] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [sensorConfig, setSensorConfig] = useState({});
  const [importResults, setImportResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfiles = async () => {
      await fetchalertprofiles();
    };
    fetchProfiles();
  }, [fetchalertprofiles]);

  const handleStep1Complete = (devices) => {
    setChirpStackDevices(devices);
    setCurrentStep(2);
  };

  const handleStep2Complete = (devices) => {
    setSelectedDevices(devices);
    setCurrentStep(3);
  };

  const handleStep3Complete = (config) => {
    setSensorConfig(config);
    importDevices(config);
  };

  const handleStep4Complete = (syncResults) => {
    // Import en sync voltooid, ga naar sensor overzicht
    alert("ChirpStack import en synchronisatie voltooid!");
    navigate("/sensoren");
  };

  const handleStep4Skip = () => {
    // Sync overgeslagen, ga naar sensor overzicht
    alert("ChirpStack import voltooid! Synchronisatie overgeslagen.");
    navigate("/sensoren");
  };

  const importDevices = async (config) => {
    setLoading(true);
    setError("");

    try {
      const response = await fetch("/api/admin/sensors/chirpstack/import", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify({
          devices: selectedDevices,
          sensorConfig: config,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setImportResults(data);
        setCurrentStep(4); // Ga naar synchronisatie stap
      } else {
        setError(data.error || "Import mislukt");
      }
    } catch (error) {
      console.error("Import fout:", error);
      setError("Er is een fout opgetreden bij het importeren");
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      // Reset error state when going back
      if (currentStep === 4) {
        setError("");
      }
    }
  };

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">ChirpStack Sensoren Importeren</h3>
        <div className="box-tools pull-right">
          <span className="badge bg-blue">Stap {currentStep} van 4</span>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile">
              {error && (
                <div className="alert alert-danger">
                  <strong>Fout:</strong> {error}
                </div>
              )}

              {loading && (
                <div className="text-center">
                  <i className="fa fa-spinner fa-spin"></i> Bezig met importeren...
                </div>
              )}

              {!loading && (
                <>
                  {currentStep === 1 && (
                    <ChirpStackStep1 onComplete={handleStep1Complete} />
                  )}

                  {currentStep === 2 && (
                    <ChirpStackStep2 
                      devices={chirpStackDevices}
                      onComplete={handleStep2Complete}
                      onBack={goBack}
                    />
                  )}

                  {currentStep === 3 && (
                    <ChirpStackStep3
                      devices={selectedDevices}
                      alertprofile={alertprofile}
                      onComplete={handleStep3Complete}
                      onBack={goBack}
                    />
                  )}

                  {currentStep === 4 && (
                    <ChirpStackStep4
                      devices={selectedDevices}
                      onComplete={handleStep4Complete}
                      onSkip={handleStep4Skip}
                      onBack={goBack}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alertprofile: state.alertprofile.items,
});

export default connect(mapStateToProps, { fetchalertprofiles })(ChirpStackImportWizard);